import { splitLines, unquote } from '../detect.js';
const REQ_RE = /^\s*(requirement|functionalRequirement|nonFunctionalRequirement|performanceRequirement|interfaceRequirement|physicalRequirement|designConstraint)\s+(\S+)\s*(?:\{\s*([\s\S]*?)\s*\})?\s*$/;
const ELEMENT_RE = /^\s*element\s+\{\s*([\s\S]*?)\s*\}\s*$/;
const RELATION_RE = /^\s*(contains|copies|derivesFrom|satisfies|verifies|refines|traces)\s+(\S+?)\s*,\s*(\S+)\s*$/;
export const parseRequirement = (source) => {
    const lines = splitLines(source);
    const nodes = new Map();
    const edges = [];
    const groups = [];
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || /^requirementDiagram\b/i.test(line))
            continue;
        const el = ELEMENT_RE.exec(line);
        if (el) {
            const body = el[1] ?? '';
            const idMatch = /\bid:\s*(\S+)/i.exec(body);
            const nameMatch = /\bname:\s*"?([^"\n]+)"?/i.exec(body);
            const typeMatch = /\btype:\s*(\S+)/i.exec(body);
            if (idMatch) {
                const id = idMatch[1];
                nodes.set(id, {
                    id,
                    label: unquote(nameMatch?.[1] ?? id),
                    shape: 'document',
                    meta: { type: typeMatch?.[1] ?? 'requirement' },
                });
            }
            continue;
        }
        const r = REQ_RE.exec(line);
        if (r) {
            const [, kind, id, body] = r;
            if (!id)
                continue;
            const nameMatch = /\bid:\s*(\S+)/i.exec(body ?? '');
            const labelMatch = /\bname:\s*"?([^"\n]+)"?/i.exec(body ?? '');
            const label = labelMatch?.[1] ?? nameMatch?.[1] ?? id;
            nodes.set(id, {
                id,
                label: unquote(label),
                shape: 'document',
                meta: { kind },
            });
            continue;
        }
        const rel = RELATION_RE.exec(line);
        if (rel) {
            const [, , from, to] = rel;
            if (!from || !to)
                continue;
            edges.push({ id: `e_${edges.length}_${from}_${to}`, from, to });
        }
    }
    return {
        type: 'requirement',
        nodes: Array.from(nodes.values()),
        edges,
        groups,
        styles: {},
        meta: {},
    };
};
//# sourceMappingURL=requirement.js.map